<div class="mobile-navbar" [ngClass]="{'transparent': transparent}">
    <i *ngIf="showBackButton" class="icon-smash_back_arrow button-back-arrow" (click)="back()"></i>
    <i class="smash-header-logo icon-smash_logo_no_chip"></i>
    <app-smash-burger-menu-mobile (menuToggle)="onBurgerMenuToggle($event)"></app-smash-burger-menu-mobile>
    <ng-content></ng-content>
</div>
